import React from "react";

import { clientes } from "../../../datos";

export function Clientes() {
  const { title, subtitle, list } = clientes;
  return (
    <section className="my-[70px] xl:my-[90px]">
      <div className="container mx-auto">
        <div className="text-center">
          <h2
            className="h2 mb-0 xl:mb-0"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            {title}
          </h2>
          <p
            className="lead max-w-[584px] mx-auto mb-16 xl:mb-24 text-2xl"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            {subtitle}
          </p>
        </div>
        <div className="w-full md:flex md:space-x-2 md:justify-around mt-3">
          {list.map((item, index) => {
            const { title, descripcion, delay } = item;
            return (
              <div
                key={index}
                className="Card"
                // data-aos="zoom-in"
                // data-aos-offset="100"
                // data-aos-delay={delay}
              >
                <div className=" bg-blue-700 h-28 rounded-t-lg">
                  <div className="text-3xl font-bold mt-2 mx-2 pt-10 px-5 items-center text-white">
                    {title}
                  </div>
                </div>
                <div className="text-lg text-gray-700 mx-2 mt-2">
                  {descripcion}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
